import React from 'react';
import Icon from '../../../components/AppIcon';

const OnboardingTimeline = ({ steps }) => {
  const getStatusIcon = (status) => {
    const icons = {
      completed: { name: 'CheckCircle', color: 'text-success', bg: 'bg-success/10' },
      in_progress: { name: 'Clock', color: 'text-warning', bg: 'bg-warning/10' },
      pending: { name: 'Circle', color: 'text-muted-foreground', bg: 'bg-muted' }
    };
    return icons?.[status] || icons?.pending;
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date?.toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
      <h3 className="text-lg font-semibold text-foreground mb-6">Onboarding Timeline</h3>

      <div className="space-y-6">
        {steps?.map((step, index) => {
          const statusIcon = getStatusIcon(step?.status);
          const isLast = index === steps?.length - 1;

          return (
            <div key={step?.id} className="relative">
              {/* Connector Line */}
              {!isLast && (
                <div className="absolute left-6 top-12 bottom-0 w-0.5 bg-border"></div>
              )}

              <div className="flex gap-4">
                {/* Icon */}
                <div className={`flex-shrink-0 w-12 h-12 rounded-full ${statusIcon?.bg} flex items-center justify-center`}>
                  <Icon name={statusIcon?.name} size={24} className={statusIcon?.color} />
                </div>

                {/* Content */}
                <div className="flex-1 pb-6">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h4 className="text-base font-semibold text-foreground mb-1">{step?.title}</h4>
                      <p className="text-sm text-muted-foreground">{step?.description}</p>
                    </div>
                    <div className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${
                      step?.status === 'completed' ? 'bg-success/10 text-success' :
                      step?.status === 'in_progress'? 'bg-warning/10 text-warning' : 'bg-muted text-muted-foreground'
                    }`}>
                      {step?.status?.replace('_', ' ')}
                    </div>
                  </div>

                  {/* Date */}
                  {step?.date && (
                    <div className="flex items-center gap-2 mt-3">
                      <Icon name="Calendar" size={14} className="text-muted-foreground" />
                      <span className="text-xs text-muted-foreground">{formatDate(step?.date)}</span>
                    </div>
                  )}

                  {/* Additional Info */}
                  {step?.status === 'in_progress' && (
                    <div className="mt-3 p-3 rounded-lg bg-warning/5 border border-warning/20">
                      <div className="flex items-start gap-2">
                        <Icon name="AlertCircle" size={16} className="text-warning mt-0.5" />
                        <p className="text-xs text-warning">Action required: Complete verification documents</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OnboardingTimeline;